import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../reducers';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ResetPassword } from '../reduxactions/ResetActions';

export const Reset = () => {

  const uid = window.sessionStorage.getItem('uid');
  const dispatch = useDispatch();
  const password = useSelector((state: RootState) => state.reset.reset);
  const [countrycode, setcountrycode] = useState<any>('');
  const [oldpass, setoldpass] = useState<any>('');
  const [newpass, setnewpass] = useState<any>('');
  const [renewpass, setrenewpass] = useState<any>('');


  const msgs = useRef(null);


  const toast = useRef(password);
  const regsdata = async () => {
    try {
      await dispatch(ResetPassword(oldpass, newpass, renewpass, uid) as any);
      setoldpass('');
      if (password && password.length > 0) {
        if (password == "Password Successfully Changed") {
          toast.current.show({ severity: 'success', summary: 'success', detail: password, life: 3000 })
        } else {
          toast.current.show({ severity: 'info', summary: 'info', detail: password, life: 3000 })
        }
      }
    } catch (error) {
      console.error('Error fetching data', error)
    } finally {
      setoldpass('');
      setnewpass('');
      setrenewpass('');
    }

  }

  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/doctor-resetlogout.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div>
      <div className="content-wrapper">
        
        <section className="content-header">
          <div>
            <h1 className="text-red" style={{ marginTop: '70px' }}>Reset Password</h1>
          </div>
           <div className="col-16" style={{ textAlign:"right"}}>
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
        </section>
        <section className="content">
          <div className="grid">
            <div className="col-2"></div>
            <div className="col-9">
              <div className="flex flex-column font-bold m-2 border-round border-1 border-blue-500" style={{ width: "100%", padding: "20px" }}>
                <div className="grid">
                  <div className="col-2"></div>
                  <div className="col-3">
                    <label htmlFor="oldpass" className="block text-900 font-medium mb-2">Old Password</label>
                  </div>
                  <div className="col-5">
                    <InputText type="password" id="oldpass" style={{ width: '25vw' }} value={oldpass} onChange={(e) => setoldpass(e.target.value)} />
                  </div>
                  <div className="col-2"></div>
                </div>
                <div className="grid">
                  <div className="col-2"></div>
                  <div className="col-3">
                    <label htmlFor="newpass" className="block text-900 font-medium mb-2">New Password</label>
                  </div>
                  <div className="col-5">
                    <InputText type="password" id="newpass" style={{ width: '25vw' }} value={newpass} onChange={(e) => setnewpass(e.target.value)} />
                  </div>
                  <div className="col-2"></div>
                </div>
                <div className="grid">
                  <div className="col-2"></div>
                  <div className="col-3">
                    <label htmlFor="renewpass" className="block text-900 font-medium mb-2">Confirm New Password</label>
                  </div>
                  <div className="col-5">
                    <InputText type="password" id="renewpass" style={{ width: '25vw' }} value={renewpass} onChange={(e) => setrenewpass(e.target.value)} />
                  </div>
                  <div className="col-2"></div>
                </div>
              </div>
              <div className="grid">
                <div className="col-3"></div>
                <div className="col-9">
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      label="Update"
                      onClick={regsdata}
                      disabled={oldpass.trim() === '' || newpass.trim() === '' || renewpass.trim() === ''}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
          <Toast ref={toast} />
        </section>
      </div>
    </div>
  )
}